// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__Ta6bA","topBottomGutter":"Layout_topBottomGutter__116aD"};